
<template>
  <div>
    <CCard>
      <CCardBody>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <CForm @submit.stop.prevent="handleSubmit(submit)">
            <CRow>
              <CCol md="6">
                <validation-provider rules="required" v-slot="{ errors }" name="Nama Waktu Kerja">
                  <CInput
                    label="Nama Waktu Kerja"
                    v-model="form.time_name"
                    :invalid-feedback="errors[0]"
                    :isValid="!errors[0]"
                  ></CInput>
                </validation-provider>
                <validation-provider rules="required" v-slot="{ errors }" name="Jam Masuk">
                  <div role="group" class="form-group">
                    <label class>Jam Masuk</label>
                    <datetime 
                        format="H:i" 
                        name='start_time' 
                        v-model="form.start_time"
                        :invalid-feedback="errors[0]"
                        :isValid="!errors[0]"
                    ></datetime>
                  </div>
                </validation-provider>
                <validation-provider rules="required" v-slot="{ errors }" name="Jam Pulang">
                  <div role="group" class="form-group">
                    <label class>Jam Pulang</label>
                    <datetime 
                        format="H:i" 
                        name='end_time' 
                        v-model="form.end_time"
                        :invalid-feedback="errors[0]"
                        :isValid="!errors[0]"
                    ></datetime>
                  </div>
                </validation-provider>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="6" class="text-left">
                <CSpinner color="success" size="sm" v-if="loading" />
                <CButton color="primary" class="px-4" type="submit" v-else>Simpan</CButton>
              </CCol>
            </CRow>
          </CForm>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import datetime from 'vuejs-datetimepicker';

import Swal from "sweetalert2";

export default {
  name: "FormOfficeTime",
  props: ["item"],
  components: {
    ValidationProvider,
    ValidationObserver,
    datetime
  },
  data() {
    return {
      errorMessage: null,
      form: {
        time_name: null,
        start_time: null,
        end_time: null
      },
      loading: false,
    };
  },
  watch: {
    item: function (item) {
      if (item) {
        this.form.time_name = item.time_name;
        this.form.start_time = item.start_time;
        this.form.end_time = item.end_time;
      }
    },
  },
  methods: {
    async submit() {
      const vm = this;
      try {
        this.loading = true;
        let { status } = this.item
          ? await this.$store.dispatch("general/update", {
              url: '/api/master/office-time',
              data: this.form,
              id: vm.item.id,
            })
          : await this.$store.dispatch("general/store", {url: 'api/master/office-time', data: this.form});
        if (status >= 200 && status <= 202) {
          Swal.fire({
            title: "Sukses",
            text: "Data berhasil tersimpan!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Tutup!",
          }).then(() => {
            if (!vm.item) {
              vm.form.nama_layanan = null;
              requestAnimationFrame(() => {
                this.$refs.observer.reset();
              });
            }
            vm.$emit("done");
          });
        }
      } catch (x) {
        console.log(x);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
